import '../../styles/Auth.css';

import {sendPasswordResetEmail} from 'firebase/auth';
import {useState} from 'react';
import {Link} from 'react-router-dom';

import {auth} from '../../firebase';

// Helper function to get user-friendly error messages
const getErrorMessage = (errorCode) => {
  switch (errorCode) {
    case 'auth/invalid-email':
      return 'Invalid email address format.';
    case 'auth/user-not-found':
      return 'No account found with this email.';
    case 'auth/too-many-requests':
      return 'Too many requests. Please try again later.';
    case 'auth/missing-android-pkg-name':
    case 'auth/missing-continue-uri':
    case 'auth/missing-ios-bundle-id':
    case 'auth/invalid-continue-uri':
    case 'auth/unauthorized-continue-uri':
      return 'There was a configuration error. Please contact support.';
    default:
      return 'An error occurred. Please try again later.';
  }
};

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Validation function
  const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    // Validate email
    if (!validateEmail(email)) {
      setError('Please enter a valid email address.');
      setLoading(false);
      return;
    }

    try {
      // Send password reset email using Firebase
      await sendPasswordResetEmail(auth, email, {
        url: 'https://manager.tenvos.com/login',
        handleCodeInApp: false,
      });

      setMessage(
        'Password reset link sent! Check your email inbox (and spam folder).',
      );
      setEmail('');
    } catch (error) {
      setError(getErrorMessage(error.code));
      console.error('Password reset error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='auth-container'>
      <div className='auth-card'>
        <h2>Reset Your Password</h2>

        {message && <div className='auth-message'>{message}</div>}
        {error && <div className='auth-error'>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className='form-group'>
            <label htmlFor='email'>Email</label>
            <input
              type='email'
              id='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              placeholder='Enter your account email'
            />
          </div>

          <button type='submit' className='auth-button' disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className='auth-links'>
          <Link to='/login' className='auth-link'>
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
